import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const salesOrderModule = () => import('./sales-order.module').then((m) => m.SalesOrderModule);

export const salesOrderRoutes: Routes = [
  {
    path: 'sales-order',
    canActivateChild: [RoleGuard],
    loadChildren: salesOrderModule,
    data: {
      enum: 'SALES_ORDER',
      label: 'Sales Order',
      icon: 'ic_task_alt.svg',
      path: 'sales-order',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_SO_ALL',
          label: 'List Sales Order',
          path: 'sales-order/list',
          children: [],
        },
        {
          enum: 'LIST_SO_MENUNGGU',
          label: 'Menunggu Konfirmasi',
          path: 'sales-order/pending/center',
          children: [],
        },
        {
          enum: 'LIST_SO_DIPROSES',
          label: 'Diproses',
          path: 'sales-order/onprogress',
          children: [],
        },
        {
          enum: 'LIST_SO_HISTORY',
          label: 'Histori',
          path: 'sales-order/history',
          children: [],
        },
      ],
    },
  },
];
